module.exports = __webpack_public_path__ + "img/ico_task_message.434b34ec.svg";